import React, { useState } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { dictionaries } from "../i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, supportedLangs, switchLang, t } = useLanguage();
  const currentName = dictionaries[lang]?.lang_name || lang.toUpperCase();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="inline-flex items-center gap-1.5 rounded-full border border-ink/15 bg-white/70
                   backdrop-blur px-3 py-2 text-xs font-medium uppercase tracking-[0.18em]
                   text-ink/80 hover:text-ink hover:border-ink/40 transition-colors cursor-pointer"
        aria-label={t("lang_switch")}
        asChild={false}
      >
        <Globe className="h-3.5 w-3.5" aria-hidden="true" />
        <span data-testid="current-language">{lang.toUpperCase()}</span>
        <span className="hidden sm:inline text-ink/50 normal-case tracking-normal">· {currentName}</span>
        <ChevronDown className="h-3 w-3 text-ink/40" />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[180px] z-[200]"
        sideOffset={8}
      >
        {supportedLangs.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`lang-option-${l}`}
            onClick={() => switchLang(l)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <span className="text-xs uppercase tracking-[0.18em] text-ink/60 w-7">{l}</span>
              <span>{dictionaries[l]?.lang_name || l}</span>
            </span>
            {l === lang ? <Check className="h-4 w-4 text-gold" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
